"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Titania = void 0;
const Colony_1 = require("../../../colonies/Colony");
const Resources_1 = require("../../../Resources");
const ColonyName_1 = require("../../../colonies/ColonyName");
const ColonyBenefit_1 = require("../../../colonies/ColonyBenefit");
class Titania extends Colony_1.Colony {
    constructor() {
        super(...arguments);
        this.name = ColonyName_1.ColonyName.TITANIA;
        this.description = 'VP';
        this.buildType = ColonyBenefit_1.ColonyBenefit.GAIN_VP;
        this.buildQuantity = [5, 3, 2];
        this.tradeType = ColonyBenefit_1.ColonyBenefit.GAIN_VP;
        this.tradeQuantity = [3, 2, 2, 2, 1, 1, 1];
        this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.LOSE_RESOURCES;
        this.colonyBonusQuantity = 3;
        this.colonyBonusResource = Resources_1.Resources.MEGACREDITS;
        this.shouldIncreaseTrack = Colony_1.ShouldIncreaseTrack.NO;
        this.priority = 0;
        this.details = [
            'Gain 5 / 3 / 2 VP',
            'Gain n VP',
            'Lose 3 M€, or as much as possible',
        ];
    }
}
exports.Titania = Titania;
//# sourceMappingURL=Titania.js.map